<template>
  <section class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-lg-4">
        <div class="login-panel text-left">
          <div
            class="alert alert-primary"
            role="alert"
            :style="{ opacity: isAlertShow ? 1 : 0 }"
          >
            Login successfully. <small>waiting for redirect.</small>
            <loader-component width="30"></loader-component>
          </div>
          <div v-if="!loggedin">
            <h1 class="display-3 font-weight-bold">Login</h1>
            <p class="font-weight-bold">Welcome back</p>
            <br />
            <form action="">
              <div class="form-group">
                Email
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  placeholder="Email"
                  v-model="email"
                />
              </div>
              <div class="form-group">
                Password
                <input
                  type="password"
                  id="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="password"
                />
              </div>
              <br />
              <div class="form-group d-flex justify-content-center">
                <button
                  class="btn btn-primary w-25"
                  id="login"
                  @click.prevent="login()"
                  v-if="!isLoggingIn"
                >
                  Login
                </button>
                <button
                  class="btn btn-primary w-25"
                  disabled
                  @click.prevent="login"
                  v-if="isLoggingIn"
                >
                  <loader-component width="30"></loader-component>
                </button>
              </div>
              <router-link :to="{ path: '/forgot-password' }"
                >Forgot your password?</router-link
              >
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { setTimeout } from "timers";
import LoaderComponent from "../components/LoadingComponent";
import axios from "axios";
import { sha256, sha224 } from "js-sha256";
import { access } from "fs";

export default {
  components: { LoaderComponent },
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      isLoggingIn: false,
      isAlertShow: false,
      loggedin: !(localStorage.getItem("loggedin") === null),
    };
  },

  methods: {
    login() {
      let pwd = sha256(this.password);
      axios
        .post(process.env.VUE_APP_SERVICE_URL + "api/auth/User/signin", {
          email: this.email,
          password: pwd,
        })
        .then((response) => {
          localStorage.setItem("loggedin", true);
          localStorage.setItem("accessToken", response.data.result.accessToken);
          localStorage.setItem(
            "refreshToken",
            response.data.result.refreshToken
          );
          this.loggedin = !(localStorage.getItem("loggedin") === null);

          //this.setHeader();
          //this.setrouterbeforeeach();
          setTimeout(() => {
            this.isLoggingIn = false;
            this.isAlertShow = true;
            setTimeout(() => this.redirect(), 1000);
          }, 1000);
        })
        .catch((err) => {
          alert(err);
        });
    },
    redirect() {
      this.$router.push({ name: "blog-overview" });
      //fix open blog-overview and then login bug
      location.reload();
    }
  },
  created: function () {
    if (this.loggedin) {
      this.redirect();
    }
  },
};
</script>

<style lang="scss">
.widget {
  margin: 0;
  height: unset;
}
.login-panel {
  position: relative;
  padding: 200px 0;
  .alert {
    opacity: 0;
    position: absolute;
    width: 100%;
    top: 100px;
    transition: all 0.5s;
    &.alert-primary {
      background-color: #007bff;
      color: #fff;
      font-size: 18px;
      border: none;
    }
    .widget {
      position: absolute;
      right: 5px;
      top: 0;
      margin: 10px;
    }
  }
}
</style>
